<template>
  <SmallSquare content="选择小程序卡片" class='m-b-20' />
  <div class='s_flex_bian_c m-b-20'>
    <div>
      <a-button type="primary" @click="$router.push('/wxPublic/wxManagement/drewManagement/wx_card_add?type=add')">
        新增小程序卡片</a-button>
    </div>
    <div>
      <a-form ref='form' :model='search' layout='inline'>
        <a-form-item label="关键词" name='keyword'>
          <a-input v-model:value="search.keyword" placeholder='请输入关键词进行搜索' />
        </a-form-item>
      </a-form>
    </div>
  </div>
  <a-card>
    <a-spin :spinning="listLoading">
      <ul class='s_flex_ali s_flex_wrap m-b-10'>
        <li v-for="(v,k) in msgList" :key="k" class='p-10 s_bor_cd9 '>
          <input type="radio" name="media_id" :id="v.id" hidden v-model="media" :value="v">
          <div class="mark">
            <CheckOutlined class='fz-30 s_cfff' />
          </div>
          <label :for="v.id">
            <div class="media_header p-t-10 p-b-10 m-b-5">{{v.create_time}}</div>
            <div class="media_main m-b-10" :style="{backgroundImage:'url('+info.picdomain+'/'+v.image+')'}">
              <img src="@/assets/images/bgmoren.jpg" alt="" v-if="!v.image">
            </div>
            <div class="media_foot">
              {{v.title}}
            </div>
          </label>
        </li>
      </ul>
    </a-spin>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" />
  </a-card>
  <div class='s_flex_end m-t-10'>
    <a-button @click="cancel" class='m-r-10'>取消</a-button>
    <a-button type="primary" @click="success">选择</a-button>
  </div>
</template>
<script>
  import { CheckOutlined } from "@ant-design/icons-vue";
  import { getMiniCard } from "@/api/public_wx";
  import { inject, onMounted, reactive, ref, toRefs } from "vue";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  const defForm = {
    page: 1,
    limit: 10,
    keyword: "",
    type: 1,
  };
  export default {
    name: "minicard",
    components: { CheckOutlined },
    setup(props, { emit }) {
      const state = reactive({
        listLoading: false,
        type: 1,
        media: null,
        total: 0,
        msgList: [],
        info: store.state.user.info,
      });
      const search = ref({...defForm});
      const change = (e) => {
        search.value.page = 1
        state.media = null
        initData(search.value);
      }
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getMiniCard(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          state.msgList = res.data.data;
          state.total = res.data.total;
        }
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      const $router = inject('$router')
      // 确认选择
      const success = () => {
        emit('success', state.media)
      }
      // 取消
      const cancel = () => {
        emit('cancel')
      }
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        change,
        pageCurrentChange,
        success,
        cancel
      };
    },
  };
</script>
<style lang="less" scoped>
  ul {
    li {
      height: 300px;
      overflow: hidden;
      width: 23%;
      margin: 10px 1%;
      position: relative;

      .media_header {
        border-bottom: 1px solid #eee;
      }

      .media_main {
        width: 100%;
        height: 190px;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .media_foot {
        font-weight: 600;
      }

      .mark {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: none;
        justify-content: center;
        align-items: center;
      }

      input:checked~.mark {
        display: flex;
      }
    }

    .disabled {
      opacity: .5;
    }
  }
</style>